export const ASSET_CACHE_ERROR_MESSAGE = 'Failed to load asset during caching process.';